<template>
  <svg
    aria-hidden="true"
    width="19"
    height="21"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ...attributes
  >
    <path
      d="M3.807 17.3408L3.861 17.2508C5.26352 15.0227 6.00523 12.4425 6 9.80978C6 8.74891 6.42143 7.7315 7.17157 6.98135C7.92172 6.23121 8.93913 5.80978 10 5.80978C11.0609 5.80978 12.0783 6.23121 12.8284 6.98135C13.5786 7.7315 14 8.74891 14 9.80978C14 10.8268 13.93 11.8288 13.797 12.8098M17.01 16.9418C17.655 14.6758 18 12.2828 18 9.80978C18.0003 8.40534 17.6309 7.02556 16.9289 5.80915C16.2269 4.59275 15.217 3.58259 14.0008 2.88023C12.7846 2.17787 11.4049 1.80806 10.0004 1.80798C8.596 1.8079 7.21628 2.17756 6 2.87978M1 14.1738C1.64 12.8548 2 11.3738 2 9.80978C2 8.35278 2.39 6.98678 3.07 5.80978M10 9.80978C8.74474 14.1738 7.94855 16.9418 7.247 19.3808L10 9.80978ZM11.679 19.6538C12.2962 18.4223 12.7958 17.1352 13.171 15.8098L11.679 19.6538Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
</template>
